import { useQuery } from '@tanstack/react-query';
import { ordersService } from '@/services/ordersService';
import { queryKeys } from '@/lib/queryKeys';

export function useOrders() {
  return useQuery({
    queryKey: queryKeys.orders.list(),
    queryFn: () => ordersService.listOrders(),
    staleTime: 30_000,
  });
}
